import { IsEnum, IsISO8601, IsOptional, IsString } from 'class-validator';

import { ConnectionStatus, ProviderType } from './enums';

export class GlucoseSourceConnectionStatusDto {
  @IsString()
  id!: string;

  @IsEnum(ProviderType)
  providerType!: ProviderType;

  @IsString()
  providerName!: string;

  @IsOptional()
  @IsString()
  emailOverride?: string;

  @IsEnum(ConnectionStatus)
  status!: ConnectionStatus;

  @IsOptional()
  @IsISO8601()
  lastDataValueTime?: string;

  @IsOptional()
  @IsISO8601()
  lastDataRefreshTime?: string;

  @IsOptional()
  @IsISO8601()
  lastRealTimeUpdateTime?: string;
}
